/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum for alert domains.
 * @export
 */
export const AlertDomain = {
    Capacity: 'capacity',
    Network: 'network',
    Storage: 'storage',
    S3: 's3',
    Security: 'security',
    Performance: 'performance',
    TelemetryDelay: 'telemetry_delay',
    TelemetryOutage: 'telemetry_outage',
    VitalsScore: 'vitals_score',
    Unknown: 'unknown'
} as const;
export type AlertDomain = typeof AlertDomain[keyof typeof AlertDomain];


export function instanceOfAlertDomain(value: any): boolean {
    for (const key in AlertDomain) {
        if (Object.prototype.hasOwnProperty.call(AlertDomain, key)) {
            if (AlertDomain[key as keyof typeof AlertDomain] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AlertDomainFromJSON(json: any): AlertDomain {
    return AlertDomainFromJSONTyped(json, false);
}

export function AlertDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertDomain {
    return json as AlertDomain;
}

export function AlertDomainToJSON(value?: AlertDomain | null): any {
    return value as any;
}

export function AlertDomainToJSONTyped(value: any, ignoreDiscriminator: boolean): AlertDomain {
    return value as AlertDomain;
}

